import { useEffect, useState } from "react";
import { Moon, Sun } from "lucide-react";

export function DarkModeToggle() {
  const [dark, setDark] = useState(() => {
    if (typeof window === 'undefined') return false;
    return localStorage.getItem('ps24-pro-theme') === 'dark';
  });

  useEffect(() => {
    const root = document.documentElement;
    if (dark) {
      root.classList.add('pro-dark');
      localStorage.setItem('ps24-pro-theme', 'dark');
    } else {
      root.classList.remove('pro-dark');
      localStorage.setItem('ps24-pro-theme', 'light');
    }
  }, [dark]);

  return (
    <button
      type="button"
      onClick={() => setDark(d => !d)}
      data-testid="pro-dark-toggle"
      className="w-9 h-9 grid place-items-center rounded-lg border border-slate-200 dark-bg-card dark-border text-slate-600 hover:text-emerald-600 hover:border-emerald-500 transition-colors"
      aria-label="Modo oscuro"
    >
      {dark ? <Sun className="w-4 h-4" /> : <Moon className="w-4 h-4" />}
    </button>
  );
}
